export default "__VITE_ASSET__BZNuTm_F__"